import { AuthenticationService, TranslationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { PermissionsService } from 'app/service/permission/permissions.service';
import * as CryptoJS from 'crypto-js';
import { filter, pairwise } from 'rxjs/operators';

import { CaixaService } from './../../service/caixa/caixa.service';
import { PermissoesService } from './../../service/usuario/permissoes.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  showFiller = false;

  nameUser = sessionStorage.getItem('ACS_USERNAME');
  nameUser1;
  countAuthoritys = 0;

  data: any[];

  loading = false;

  user: any;
  userAdmin = false;
  userAdministrativo = false;
  userAcervo = false;
  userProduto = false;
  clientes: ClienteModel[];

  constructor(
    translationService: TranslationService,
    private authService: AuthenticationService,
    private caixaService: CaixaService,
    private router: Router,
    private clienteService: ClienteService,
    private permissionService: PermissoesService,
    private permissaoService: PermissionsService,
    private route: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        if (
          events[0].urlAfterRedirects !== 'login' &&
          events[0].urlAfterRedirects !== '/'
        ) {
          this.loading = false;
        } else {
          this.loading = true;
        }
      });
  }

  ngOnInit() {
    //this.loading = true;
    this.data = this.clienteService.dataCliente;
    this.clienteService.dataCliente = undefined;
    this.getUserResponsavel(this.nameUser);
    this.listarClientesUsuario();
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      data => {
        this.clientes = data.content;
      },
      err => {
        console.error(err);
      }
    );
  }

  getUserResponsavel(userId: string) {
    this.caixaService.getUsuarioCaixa(userId).subscribe(
      data => {
        this.nameUser1 = data.nome;
      },
      err => {
        console.error(err);
      }
    );
  }

  setItemAuthority(key, value) {
    const store: any = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      sessionStorage.getItem('ticket-ECM')
    );
    return sessionStorage.setItem(key, store);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/home/home.component.ts